import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=0544e8a2"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"
import style0 from "./Categories.vue?vue&type=style&index=0&id=0544e8a2&prod&lang=scss"
import style1 from "./Categories.vue?vue&type=style&index=1&id=0544e8a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports